import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Availability } from './interfaces';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { formatDate, formatTime, addDays, getMonth, getDay, formatNextAvailable, getDayOfWeek } from './util';
import { IProvider } from './interfaces';
import { labels } from './labels';

interface IProps {
    availability: Availability;
    providerParams: string;
    apptType: string;
    npi: string;
    deptid: string;    
    /*
    lat: string;
    lng: string;
    */
    reason: string;    
    backto?: string;
    clinic?: string;
    phone?: string;
    who?: string;
}

interface IScheduleDates {
    prev: string;
    next: string;
}

const MiniSchedule = (props) => {
    let NUM_SLOTS = (window as any).NUM_SLOTS;
    let today = new Date();
    let wd = today.getDay();
    let ed = formatDate(addDays(today, 120));
    let addlDays = wd === 0 ? 5 : wd === 6 ? 6 : 7;
    //let firstDate = formatDate(addDays(formatDate(today), addlDays)); // props.availability.days[0].date; //formatDate(new Date());
    let firstDate = props.availability.days[0].date;
    let lastDate = formatDate(addDays(firstDate, 5));
    const [scheduleDates, setScheduleDates] = useState<IScheduleDates>({ prev: null, next: lastDate });
    const [availability, setAvailability] = useState<Availability>({ days: [], nextAvailable: null });
    const history = useHistory();

    useEffect(() => {
        setAvailability(props.availability);
    }, [props.availability])

    function updateSchedule(date: string) {
        axios.get(date ? `api/providers/${props.npi}?date=${date}&deptid=${props.deptid}&apptType=${props.apptType || ''}&reason=${props.reason || ''}` : `api/providers/${props.npi}?&deptid=${props.deptid}&apptType=${props.apptType || ''}&reason=${props.reason || ''}&who=${props.who}`)
            .then((result) => {
                var a = ((result.data) as IProvider).availability;
                var prev = formatDate(addDays(date, -5));
                if (prev < firstDate) {
                    prev = null;
                }
                const next = formatDate(addDays(date, 5));
                /*
                if (a.nextAvailable < next) {
                    a.nextAvailable = null;
                }*/
                setAvailability(a);
                setScheduleDates({ prev: prev, next: next })
            })
    }

    let available = availability.nextAvailable || (availability.days.filter(d => d.totalSlots > 0).length > 0);
    let qs = `?npi=${props.npi}&deptid=${props.deptid}&reason=${props.reason}&backto=${props.backto}`
        + (props.apptType ? `&apptType=${props.apptType || ''}` : "")
        + (props.who ? `&who=${props.who || ''}` : "");
    return (        
        <table className="table-schedule">
            <thead>
                <tr>
                    <th style={{ width: "5%" }}>{scheduleDates.prev && <a className="btn btn-xs btn-primary" style={{ padding: "2px 5px" }} title="Previous 5 days" href="#" onClick={(e) => { e.preventDefault(); updateSchedule(scheduleDates.prev); }}>&lt;</a>}</th>
                    {availability.days.map(d => (
                        <th style={{ width: "18%" }}>{getDayOfWeek(new Date(d.date))}</th>
                    ))}
                    <th style={{ width: "5%" }}>{(available && scheduleDates.next < ed && availability.nextAvailable && availability.hasFutureSlots && availability.nextAvailable < lastDate) &&
                        <a className="btn btn-xs btn-primary" style={{ padding: "2px 5px" }} title="Next 5 days" href="#" onClick={(e) => { e.preventDefault(); updateSchedule(scheduleDates.next); }}>&gt;</a>}</th>
                </tr>
                <tr>
                    <th style={{ width: "5%" }}></th>
                    {availability.days.map(d => (
                        <th style={{ width: "18%", fontWeight: "normal" }}>{getMonth(d.date)}&nbsp;{getDay(d.date)}</th>
                    ))}
                    <th style={{ width: "5%" }}></th>
                </tr>
            </thead>
            <tbody>
                <tr className="appt">
                    <td></td>
                    {availability.nextAvailable && availability.nextAvailable >= /*availability.days[availability.days.length - 1].date*/ lastDate ?
                        <td colSpan={5}>
                            <button className="btn btn-secondary btn-sm btn-schedule px-1 mb-1" style={{ fontSize: "100%", display: "inline-block", width: "100%" }} onClick={
                                () => history.push(`/provider${qs}`)}>
                                Next available {formatNextAvailable(new Date(availability.nextAvailable + "T12:00:00Z"))}
                            </button>
                        </td>
                        : !availability.nextAvailable && availability.days.filter(d => d.totalSlots > 0).length === 0 ?
                            <td colSpan={5}>
                                <span className="btn btn-sm btn-outline-secondary btn-schedule px-2 mb-1" style={{ fontSize: "100%", display: "inline-block", width: "100%", textAlign: "left" }}
                                    ref={(el) => {
                                        if (el) {
                                            el.style.setProperty('background-color', 'white', 'important');
                                            el.style.setProperty('color', 'var(--text-color)', 'important');
                                        }
                                    }}>
                                    {labels.search.noAppointments(props.clinic, props.phone)}
                                </span>
                            </td>
                            : availability.days.map(d => (
                                <td style={{ verticalAlign: "top", width: "19%" }}>
                                    {d.slots.length === 0 ?
                                        <button className="btn btn-secondary btn-sm px-1 mb-1" disabled style={{ fontSize: "100%", display: "inline-block", width: "100%", backgroundColor: "#ccc", borderColor: "#ccc" }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </button> :
                                        <>
                                            {
                                                d.slots.slice(0, (d.totalSlots > NUM_SLOTS) ? NUM_SLOTS - 1 : NUM_SLOTS).map(s => (
                                                    <Link to={{ pathname: "/newpatientcheck", search: `?npi=${props.npi}&start=${s.start}&deptid=${props.deptid}&reason=${props.reason}&apptType=${props.apptType || ''}&who=${props.who || ''}&backto=${props.backto}` }} className="btn btn-secondary btn-sm btn-schedule px-1 mb-1" style={{ fontSize: "100%", display: "inline-block", width: "100%" }}>
                                                        {formatTime(s.start, true)}
                                                    </Link>
                                                ))
                                            }
                                            {
                                                (d.totalSlots > NUM_SLOTS) &&
                                                <button className="btn btn-secondary btn-sm px-1 mb-1" style={{ fontSize: "100%", display: "inline-block", width: "100%" }} onClick={
                                                    () => history.push(`/provider${qs}`)}>
                                                    {(d.totalSlots - (NUM_SLOTS - 1))} More
                                                </button>
                                            }
                                        </>
                                    }
                                </td>
                            ))
                    }
                    <td></td>
                </tr>
            </tbody>
        </table>
    );
}

export default MiniSchedule;